import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatTabLink, MatTabNav, MatTabNavPanel } from '@angular/material/tabs';
import { NavigationEnd, Router, RouterLink, RouterLinkActive, RouterOutlet, TitleStrategy } from '@angular/router';
import { filter, map, startWith } from 'rxjs';

@Component({
  selector: 'app-my-payrolls',
  templateUrl: './my-payrolls.component.html',
  styleUrls: ['./my-payrolls.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatTabNav, MatTabLink, MatTabNavPanel, RouterLink, RouterLinkActive, RouterOutlet],
})
export class MyPayrollsComponent {
  private readonly router = inject(Router);
  private readonly title_strategy = inject(TitleStrategy);

  readonly nav_links = [
    { label: 'Mi retribución', link: './compensation' },
    { label: 'Mis nóminas', link: './payslips' },
  ];

  readonly page_title = toSignal(
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      map(() => this.title_strategy.buildTitle(this.router.routerState.snapshot)),
      startWith(this.title_strategy.buildTitle(this.router.routerState.snapshot))
    )
  );
}
